import { Pipe, PipeTransform } from '@angular/core';
import { DictionaryService } from '../service/dictionary.service';

@Pipe({
    name: 'dictionary',
    pure: false,
    standalone: false
})
export class DictionaryPipe implements PipeTransform {

  constructor(private service: DictionaryService) {
  }

  transform(key: string, ...args: any[]): string {
    const str = this.service.localize(key);
    if (!args.length) {
      return str;
    } else {
      return this.format(str, ...args);
    }
  }

  private format(format, ...args) {
    return format.replace(/{(\d+)}/g, function (match, number) {
      return typeof args[number] != 'undefined'
        ? args[number]
        : match;
    });
  };
}
